export default "__VITE_ASSET__BKOO_rur__"